import { spacingMixin } from '../spacingMixin';

/** @class ImageMixin */
/** @method */
export var ImageMixin = spacingMixin;